export default {
    widgets: {
        available_credits_to_rescue: 'Créditos disponíveis para resgate',
        points_rescued: {
            title: 'O que são Créditos Resgatados?',
            text: 'Os créditos resgatados correspondem ao histórico de resgates acumulados.'
        },
        points_to_be_released: {
            title: 'O que são Créditos em Análise?',
            text: `
                <p>Os "Créditos em análise" representam comissões de vendas pendentes, aguardando confirmação da empresa parceira antes de serem creditadas na sua conta.</p> 
                <p>Essa é uma prática comum para evitar fraudes ou problemas com os pedidos.</p>
                <p><strong>Esses créditos em análise, caso confirmados, ficarão disponíveis para resgate.</strong></p>
            `
        },
        points_expired: {
            title: 'O que são Créditos Expirados?',
            text: 'Créditos que não foram resgatados até a data limite para resgate'
        },
        points_expire_soon: {
            title: 'O que são Créditos a Expirar?',
            text: 'São créditos com validade definida, programados para expirar nos próximos meses. Utilize-os antes do prazo para aproveitá-los ao máximo!'
        },
    },
    payment_details: {
        helpers: {
            type_open: {
                title: 'O que é o Valor a receber?',
                text: `
                    O <strong>Valor a receber</strong> é a soma de todos os resgates feitos até a data de fechamento do período.
                `
            },
            open_and_closed_period_summary: { 
                text: `
                <div>
                    <span class="tw-text-base q-pb-md"><strong>O que é período aberto?</strong></span> 
                        <p class="q-ma-none tw-text-sm" style="padding: 4px 0px 0px 0px">
                            O período em aberto está aguardando aprovação de fechamento pela marca parceira.
                        </p>
                    
                    <hr class="q-my-md" style="border-color: #e2e8f0">

                    <span class="tw-text-base q-pb-sm"><strong>O que é período fechado?</strong></span>
                        <p 
                            class="q-ma-none tw-text-sm" 
                            style="padding: 4px 0px 0px 0px"
                        >
                            Depois que o período fecha:
                        </p>

                        <ul 
                            style="list-style: none; display: grid; gap: 0.4rem" 
                            class="q-pl-xs tw-text-sm"
                        >
                            <li>1. Pedimos sua Nota Fiscal.</li>
                            <li>2. Verificamos se está tudo certo.</li>
                            <li>3. Com a nota aprovada, o pagamento é feito.</li>
                        </ul>
                </div>
                `
            }
        }
    },
    no_credits_to_rescue: 'Não há créditos para serem resgatados',
    you_dont_have_the_minimum_value_to_rescue: 'Você não possui o valor mínimo para resgate de'
}
